/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HD YouTube Thumbnail Downloader (1280×720) | Toolverse`)
};

const es_yt_hd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descargador de Miniaturas HD de YouTube (1280×720) | Toolverse`)
};

const de_yt_hd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HD-YouTube-Thumbnail-Downloader (1280×720) | Toolverse`)
};

const nl_yt_hd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HD YouTube Thumbnail Downloader (1280×720) | Toolverse`)
};

const fr_yt_hd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargeur de miniatures YouTube HD (1280×720) | Toolverse`)
};

const it_yt_hd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader Miniature YouTube HD (1280×720) | Toolverse`)
};

const pt_br2_yt_hd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader de Thumbnail HD do YouTube (1280×720) | Toolverse`)
};

const pt_yt_hd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Downloader de Miniaturas HD do YouTube (1280×720) | Toolverse`)
};

const ja_yt_hd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HD YouTubeサムネイルダウンローダー（1280×720）| Toolverse`)
};

const zh_yt_hd_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HD YouTube 缩略图下载器（1280×720） | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hd_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hd_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hd_meta_title", locale)
	if (locale === "en") return en_yt_hd_meta_title(inputs)
	if (locale === "es") return es_yt_hd_meta_title(inputs)
	if (locale === "de") return de_yt_hd_meta_title(inputs)
	if (locale === "nl") return nl_yt_hd_meta_title(inputs)
	if (locale === "fr") return fr_yt_hd_meta_title(inputs)
	if (locale === "it") return it_yt_hd_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hd_meta_title(inputs)
	if (locale === "pt") return pt_yt_hd_meta_title(inputs)
	if (locale === "ja") return ja_yt_hd_meta_title(inputs)
	return zh_yt_hd_meta_title(inputs)
};